export default "__VITE_ASSET__Bg021GOh__"